module.exports = __webpack_public_path__ + "img/06.452d7ba6.jpg";